const AddressOverview = () => import('@/views/address/list.vue');

export default [
    { path: "/addresses", name: "relation_address_list", component: AddressOverview, meta: { title: "Addresses" } },
];
